var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVolumeMute24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "m6.313 7.48.216-.031.183-.118 6.688-4.3v17.937L6.712 16.67l-.183-.118-.216-.03-3.426-.49a.8.8 0 0 1-.687-.792V8.76a.8.8 0 0 1 .687-.792l3.426-.49ZM16 9l6 6m0-6-6 6"
})));
export default SvgVolumeMute24;